import { NavIcon } from './NavIcon';
import { MOBILE_TAB_IDS, NAV_ITEMS } from './navigation';
import type { ScreenId } from './navigation';

interface MobileTabsProps {
  current: ScreenId;
  onNavigate: (screen: ScreenId) => void;
  onOpenMore: () => void;
}

const MORE_ICON = 'M5 12h.01M12 12h.01M19 12h.01';

/** Barra inferior do celular: três atalhos + "Mais". */
export function MobileTabs({ current, onNavigate, onOpenMore }: MobileTabsProps) {
  const tabs = NAV_ITEMS.filter((item) => MOBILE_TAB_IDS.includes(item.id));
  const moreActive = !MOBILE_TAB_IDS.includes(current);

  const tabClass = (active: boolean) =>
    `relative flex min-h-12 flex-1 flex-col items-center gap-[3px] rounded-[10px] px-1 py-[7px] text-[10.5px] font-extrabold ${
      active ? 'text-navy-800' : 'text-ink-400'
    }`;

  return (
    <nav
      className="border-line-200 desktop:hidden flex shrink-0 border-t bg-white px-2 pt-1.5 pb-[calc(8px+env(safe-area-inset-bottom))]"
      aria-label="Menu"
    >
      {tabs.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onNavigate(item.id)}
          aria-current={item.id === current ? 'page' : undefined}
          className={tabClass(item.id === current)}
        >
          <NavIcon path={item.icon} size={21} />
          {item.label}
        </button>
      ))}

      <button type="button" onClick={onOpenMore} className={tabClass(moreActive)}>
        <NavIcon path={MORE_ICON} size={21} />
        Mais
      </button>
    </nav>
  );
}
